/* eslint-disable no-unused-vars */
import AdAccountService from "@/services/data/ad-account";

import { SET_DATA, SET_PAGINATION } from "./types";

export async function fetchData({commit}, params) {
  const {data} = await AdAccountService.get(params);
  const {accounts, pagination} = data.data;
  commit(SET_DATA, accounts);
  commit(SET_PAGINATION, pagination);
  return accounts;
}

export async function fetchDataByFbId({commit}, fbId) {
  const {data} = await AdAccountService.getByFbId(fbId);
  const {ads} = data.data;
  commit(SET_DATA, ads);
  return ads;
}

export async function importData({commit}, params) {
  const {data} = await AdAccountService.import(params);
  return data;
}

export async function exportData({commit}, params) {
  const {data} = await AdAccountService.export(params);
  return data;
}

export async function deleteData({commit}, params) {
  const {data} = await AdAccountService.delete(params);
  return data;
}